
import { Tag } from "antd"
import { useEffect, useState } from "react"
import { URL_BACKEND } from "../../api/url"
import { filters_carreras } from "../../data/datos"
import { Excel } from "antd-table-saveas-excel";

const useReporteAspiranteExamenPendiente = () => {

    // variables
    const [loading, setLoading] = useState( true )
    const [data, setData] = useState()
    const [datosReportePendiente, setDatosReportePendiente] = useState( [] )
    const [textoBuscar, setTextoBuscar] = useState("")


    // funciones
    const aspirantesConExamenesPendientes = () => {

        setLoading( true )
        let body = new FormData()
        body.append('funcion', 'aspirantesConExamenesPendientes')

        fetch( URL_BACKEND, {
            body,
            method: 'post'
        })
        .then( r => r.json() )
        .then( d => {
            setData( d )
            setDatosReportePendiente( d )
            setLoading( false )
        })
    }


    const filtrar = ( cosaABuscar ) => {

        cosaABuscar = cosaABuscar.trim()

        if (cosaABuscar) {
            // aquí haremos una búsqueda porque el usuario escribió algo
            var resultadosNuevos = data.filter( function( elemento ){
                
                let busqueda = new RegExp( cosaABuscar, 'gi' )
                if ( busqueda.test( elemento.nombre ) ) {
                    return true
                } else {
                    return false
                }

            })
            setDatosReportePendiente( resultadosNuevos )

        } else {
            // aquí no haremos la búsqueda, pero devolvemos todos los elementos
            setDatosReportePendiente( data )
        }
    }


    const exportarExcel = () => {
        const excel = new Excel();
        excel
          .addSheet("Aspirantes pendientes")
          .addColumns( columns )
          .addDataSource( datosReportePendiente , {
            str2Percent: true
          })
          .setTHeadStyle({
            fontName: 'arial'
          })
          .setTBodyStyle({
            fontName: 'arial'
          })
          .saveAs("Aspirantes con exámenes pendientes.xlsx");
      };


    // useEffects
    useEffect(() => {
        aspirantesConExamenesPendientes()
    }, [])

    useEffect(() => {
      
        filtrar( textoBuscar )

    }, [ textoBuscar ])


    // tabla
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'nombre'
        },
        {
            title: 'Carrera',
            dataIndex: 'nom_carrera',
            filters: filters_carreras,
            onFilter: (value, record) => record.nom_carrera.indexOf(value) === 0,
        },
        {
            title: 'Materia',
            dataIndex: 'materia',
            render: ( e ) => {
                if ( e == null ) {
                    return <Tag color="gold">3 materias pendientes</Tag>
                }

                return e
            }
        },
        // {
        //     title: 'Estatus',
        //     dataIndex: 'estado',
        //     render: ( e ) => {
        //         if ( e == 0 ) {
        //             return <Tag color="gold">No finalizado</Tag>
        //         }
        //     }
        // }
    ];


    return {
        loading,
        columns,
        datosReportePendiente,
        filtrar,
        textoBuscar,
        setTextoBuscar,
        exportarExcel
    }
}

export default useReporteAspiranteExamenPendiente
